import { doc, getFirestore, setDoc } from "firebase/firestore";
import { DateTime } from "luxon";
import { ReceiptRequest } from "../types/ReceiptRequest";
import { RequestStatus } from "../types/Type";

export const updateReceiptRequest = async (receiptRequest: ReceiptRequest, status: RequestStatus) => {
  const db = getFirestore();

  await setDoc(
    doc(db, `Employees/${receiptRequest.idNumber}/ReceiptRequests/${receiptRequest.id}`),
    { status, dateResponded: DateTime.utc().toISO() },
    { merge: true }
  );
};